module.exports = __webpack_public_path__ + "bRIe_XFrtjaX0I2nF/tandc_icon.svg";